import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

export default function LanguageWrapper() {
  const { i18n } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()


  useEffect(()=>{
    navigate(`/${i18n.language}`)
  },[])

  return (
    <Outlet />
  )
}
